export * from './static-labels-provider'
export * from './static-labels-provider.types'
